import { Injectable, inject } from '@angular/core';
import { Observable, of, switchMap, tap } from 'rxjs';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { blank } from '@web/utils';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';

@Injectable({
  providedIn: 'root',
})
export class FileSaverService {
  private readonly http = inject(HttpClient);

  public saveAsFromLink(url: string, name = ''): Observable<void> {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      tap((blob) => this.saveAs(blob, name)),
      blank(),
    );
  }

  public saveAs(blob: Blob, name = ''): Observable<void> {
    saveAs(blob, name);

    return of(void 0);
  }

  public saveAsFromBase64(data: string, name = ''): Observable<void> {
    return fromPromise(fetch(data)).pipe(
      switchMap((response) => fromPromise(response.blob())),
      tap((blob) => this.saveAs(blob, name)),
      blank(),
    );
  }
}
